const h = {
  languageText: '简体中文',
  title1: '公司简介',
  title2: '产品介绍',
  title3: '联系我们',
  bannerSubTitle: '应用出海服务厂商',
  bannerSubText1: '开放务实',
  bannerSubText2: '用户导向',
  bannerSubText3: '全球化视野',
  desc1: 'SmallStep Funvalley 小步乐谷科技成立于2021年9月，致力于应用出海、移动广告投放与变现，为全球用户提供优质产品和服务。 产品业务线覆盖港澳台、东南亚、欧美等多个地区，累计用户超1000W。',
  desc2: '小步乐谷始终保持初心，用开放务实的心态面对用户，以较高的市场敏锐度和行业发展前瞻性，持续探索和创新，精细化打磨产品，旨在将更极致的产品和服务带给全球用户。',
  phrase1: '丰富的海外产品经验',
  phrase2: '富有创造力的年轻化团队',
  phrase3: '丰富的渠道资源',
  phrase4: '注重用户体验和员工成长',
  infoTitle1: '地址',
  infoTitle2: '邮箱',
  infoDesc1: '广州市海珠区南洲路宝兴街88号202房之R143',
  infoDesc2: 'develpoer@legustudio.com',
  infoDesc3: '备案号：粤ICP备2024311654号',
  infoDesc4: '广州市小步乐谷科技有限公司',
  infoDesc5: '隐私政策',
  infoDesc6: '服务条款',
  home: '首页'
};

export default h;
